import { Quote, ArrowRight } from "lucide-react";

const testimonials = [
  {
    quote:
      "We saw 23% cost reduction on a product category we hadn't touched in 4 years. They handled everything — even the freight.",
    attribution: "VP of Operations",
    company: "$100M Distributor",
  },
  {
    quote:
      "It feels like having an internal sourcing team — but smarter, faster, and already connected to the right factories.",
    attribution: "CEO",
    company: "Industrial Supply Company",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-10 md:py-16">
      <div className="container px-4">
        <div className="max-w-2xl mb-12">
          <p className="text-sm font-semibold text-primary mb-3 tracking-wide uppercase">
            What buyers say
          </p>
          <h2 className="text-3xl md:text-[2.75rem] font-display font-bold text-foreground leading-tight tracking-tight">
            Trusted by procurement
            <br />
            teams worldwide.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="relative bg-background border border-border rounded-2xl p-8 md:p-10 hover:border-primary/20 transition-colors"
            >
              <Quote className="w-8 h-8 text-primary/15 mb-4" />
              <p className="text-lg font-display font-medium text-foreground leading-relaxed mb-6">
                "{t.quote}"
              </p>
              <div>
                <p className="text-sm font-display font-bold text-foreground">
                  {t.attribution}
                </p>
                <p className="text-sm text-muted-foreground">{t.company}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="#offices"
            className="inline-flex items-center gap-2 px-7 py-3 text-sm font-bold rounded-lg border border-border text-foreground hover:bg-secondary transition-colors"
          >
            Speak to Our Team <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
